export const BASE_PATH = Symbol('base_path');
export const AUDIENCE = Symbol('audience');
export const AXIOS = Symbol('axios');
